function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "outside_icon_",
  "data-name": "outside [icon]",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M14.832,43.2V39.219a4.292,4.292,0,0,0,1.547-1.141,2.435,2.435,0,0,0,1.141.254,2.738,2.738,0,0,0,1.75-4.844,2.738,2.738,0,0,0-1.75-4.844h-.178A4.013,4.013,0,0,0,13.666,25.6c-2.156,0-3.931,2.054-3.931,4.59v.025A2.735,2.735,0,0,0,9,35.465a2.613,2.613,0,0,0-.254,1.167,2.793,2.793,0,0,0,2.815,2.739,5.013,5.013,0,0,0,1.014-.178V43.2Z",
  transform: "translate(-7.3 -25.125)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "SUN",
  transform: "translate(9.746 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M65.241,16.163a.314.314,0,0,0,.246.154.277.277,0,0,0,.154-.031.311.311,0,0,0,.123-.4l-.707-1.23a.3.3,0,0,0-.523.277Z",
  transform: "translate(-61.919 -13.795)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M58.13,29.108a.308.308,0,0,0-.308-.308H56.408a.308.308,0,1,0,0,.615h1.415A.331.331,0,0,0,58.13,29.108Z",
  transform: "translate(-56.1 -23.694)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M60.032,21.31,58.8,20.6a.3.3,0,0,0-.277.523l1.23.707a.277.277,0,0,0,.154.031.274.274,0,0,0,.246-.154A.324.324,0,0,0,60.032,21.31Z",
  transform: "translate(-57.664 -17.988)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M59.686,34.9l-1.23.707a.293.293,0,0,0,.123.554.277.277,0,0,0,.154-.031l1.23-.707a.311.311,0,0,0,.123-.4A.271.271,0,0,0,59.686,34.9Z",
  transform: "translate(-57.626 -27.89)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M83.479,21.894a.277.277,0,0,0,.154-.031l1.23-.707a.3.3,0,1,0-.277-.523l-1.23.707a.311.311,0,0,0-.123.4A.274.274,0,0,0,83.479,21.894Z",
  transform: "translate(-74.867 -18.019)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M73.008,14.23a.308.308,0,0,0,.308-.308V12.508a.308.308,0,1,0-.615,0v1.415A.331.331,0,0,0,73.008,14.23Z",
  transform: "translate(-67.594 -12.2)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M78.856,16.256a.277.277,0,0,0,.154.031.274.274,0,0,0,.246-.154l.707-1.23a.3.3,0,1,0-.523-.277l-.707,1.23A.311.311,0,0,0,78.856,16.256Z",
  transform: "translate(-71.751 -13.764)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M86.422,28.8H85.008a.308.308,0,0,0,0,.615h1.415a.308.308,0,0,0,.308-.308A.331.331,0,0,0,86.422,28.8Z",
  transform: "translate(-75.904 -23.694)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M67.26,26.221a2.86,2.86,0,1,0-2.86-2.86A2.875,2.875,0,0,0,67.26,26.221Z",
  transform: "translate(-61.847 -17.947)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M84.832,35.61,83.6,34.9a.3.3,0,0,0-.277.523l1.23.707a.277.277,0,0,0,.154.031.274.274,0,0,0,.246-.154A.324.324,0,0,0,84.832,35.61Z",
  transform: "translate(-74.837 -27.89)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M65.61,39.3a.271.271,0,0,0-.4.123l-.707,1.23a.271.271,0,0,0,.123.4.277.277,0,0,0,.154.031.274.274,0,0,0,.246-.154l.707-1.23A.324.324,0,0,0,65.61,39.3Z",
  transform: "translate(-61.888 -30.937)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M79.256,39.356a.3.3,0,0,0-.523.277l.707,1.23a.314.314,0,0,0,.246.154.277.277,0,0,0,.154-.031.311.311,0,0,0,.123-.4Z",
  transform: "translate(-71.751 -30.898)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M73.008,40.9a.308.308,0,0,0-.308.308v1.415a.308.308,0,1,0,.615,0V41.208A.308.308,0,0,0,73.008,40.9Z",
  transform: "translate(-67.594 -32.073)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(11.691 8.743)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M59.943,62.562a1.5,1.5,0,0,0,.533-1.167,1.526,1.526,0,0,0-1.522-1.522h-.1A2.224,2.224,0,0,0,56.824,58.2a2.121,2.121,0,0,0-1.877,1.293,2.182,2.182,0,0,1,.025.406A3.113,3.113,0,0,1,53.4,62.613a1.545,1.545,0,0,0,.888,1.014,1.375,1.375,0,0,0-.152.634,1.479,1.479,0,0,0,1.446,1.522c.178,0,.482-.025.482-.1v1.851h1.268V65.707c0-.127.685-.33.938-.634a1.48,1.48,0,0,0,.659.152A1.526,1.526,0,0,0,60.45,63.7,1.385,1.385,0,0,0,59.943,62.562Z",
  transform: "translate(-53.4 -58.2)",
  fill: "#fff"
})));

var SvgEnvironment = function SvgEnvironment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.572,
    height: 18.076,
    viewBox: "0 0 20.572 18.076",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvironment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/environment.73460c9a.svg";
export { ForwardRef as ReactComponent };